import type { Module } from '@pc/core';
import { appBus } from '@pc/core';
import { getVendorSummary, probeSchemaIsExposed } from '@pc/db';
import { lazyWithReload } from '@pc/ui';
import './events';

const VendorsListPage = lazyWithReload(() => import('./pages/VendorsListPage'));
const VendorDetailPage = lazyWithReload(() => import('./pages/VendorDetailPage'));
const VendorNewPage = lazyWithReload(() => import('./pages/VendorNewPage'));
const BroadcastsListPage = lazyWithReload(() => import('./pages/BroadcastsListPage'));
const BroadcastComposerPage = lazyWithReload(
  () => import('./pages/BroadcastComposerPage'),
);
const BroadcastDetailPage = lazyWithReload(() => import('./pages/BroadcastDetailPage'));
const VendorsDashboardWidget = lazyWithReload(
  () => import('./widgets/VendorsDashboardWidget'),
);

export const vendorsModule: Module = {
  id: 'vendors',
  name: 'Vendors',
  description:
    'Upstream supplier records with tax/W9 status, lead times, minimum orders, and SKU links. On Pro and up.',
  basePath: '/vendors',
  routes: [
    { path: '/', element: <VendorsListPage /> },
    { path: '/new', element: <VendorNewPage /> },
    { path: '/broadcasts', element: <BroadcastsListPage /> },
    { path: '/broadcast/new', element: <BroadcastComposerPage /> },
    { path: '/broadcast/:id', element: <BroadcastDetailPage /> },
    { path: '/:id', element: <VendorDetailPage /> },
  ],
  navItems: [{ label: 'Vendors', to: '/vendors', order: 30 }],
  dashboardWidgets: [
    {
      id: 'recent-vendors',
      span: 1,
      order: 35,
      render: VendorsDashboardWidget,
    },
  ],
  events: {
    publishes: ['vendor.created', 'vendor.updated', 'vendor.archived'],
    subscribesTo: {
      'vendor.created': (payload) => {
        appBus().emit('app.toast', {
          text: `New vendor: ${payload.companyName}`,
          tone: 'success',
        });
      },
    },
  },
  publicApi: {
    /** Look up a vendor through the stable v_vendor_summary view. */
    getVendorSummary: getVendorSummary as unknown as (...args: never[]) => unknown,
  },
  healthProbe: () => probeSchemaIsExposed('vendors', 'v_vendor_summary'),
};
